import React from "react"
import { SignIn, SignUp, SignedIn, SignedOut } from "@clerk/clerk-react"
import { sharedStyles } from '../components/shared/sharedStyles.js'

export function AuthenticationPage() {
    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: sharedStyles.colors.background,
            padding: '2rem'
        }}>
            <SignedOut>
                <SignIn
                    routing="path"
                    path="/sign-in"
                    appearance={{
                        elements: {
                            rootBox: {
                                margin: '0 auto'
                            },
                            card: {
                                background: 'rgba(255, 255, 255, 0.85)',
                                backdropFilter: 'blur(20px)',
                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                borderRadius: '20px',
                                boxShadow: '0px 16px 64px rgba(15, 23, 42, 0.08)'
                            }
                        }
                    }}
                />
                <SignUp
                    routing="path"
                    path="/sign-up"
                    appearance={{
                        elements: {
                            rootBox: {
                                margin: '0 auto'
                            },
                            card: {
                                background: 'rgba(255, 255, 255, 0.85)',
                                backdropFilter: 'blur(20px)',
                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                borderRadius: '20px',
                                boxShadow: '0px 16px 64px rgba(15, 23, 42, 0.08)'
                            }
                        }
                    }}
                />
            </SignedOut>
            <SignedIn>
                <div style={{
                    background: 'rgba(255, 255, 255, 0.85)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    borderRadius: '20px',
                    padding: '2rem',
                    textAlign: 'center',
                    boxShadow: '0px 16px 64px rgba(15, 23, 42, 0.08)'
                }}>
                    <p style={{ color: sharedStyles.colors.textPrimary, fontSize: '1.125rem' }}>
                        You are already signed in.
                    </p>
                </div>
            </SignedIn>
        </div>
    )
}